import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetEvaluationDetailItems, IGetEvaluationItems, IGetStudentClasses, IGetCanbotEvaluationItemResponse } from '../models/mypage.model';

const uri = '/service/my-page';

export const getEvaluationItems = (langCode: string, rubricNo: number): AxiosPromise<IGetEvaluationItems> => {
  return axios.get(`${uri}/e-learning/feedback/${langCode}/${rubricNo}`);
};

export const getWritingEvaluationItems = (langCode: string, rubricNo: number): AxiosPromise<IGetEvaluationItems> => {
  return axios.get(`${uri}/e-learning/feedback-writing/${langCode}/${rubricNo}`);
};

export const getEvaluationDetailItems = (langCode: string, rubricNo: number, evaluationNo: number): AxiosPromise<IGetEvaluationDetailItems> => {
  return axios.get(`${uri}/e-learning/feedback/${langCode}/${rubricNo}/${evaluationNo}`);
};

export const getStudentClasses = (memberCode: string): AxiosPromise<IGetStudentClasses> => {
  return axios.get(`${uri}/class/${memberCode}`);
}

export const getAllStudentClasses = (memberCode: string): AxiosPromise<IGetStudentClasses> => {
  return axios.get(`${uri}/class-all/${memberCode}`);
}

export const getCanbotEvaluationItem = (resultCode: number): AxiosPromise<IGetCanbotEvaluationItemResponse> => {
  return axios.get(`${uri}/e-learning/canbot/evaluation/en/${resultCode}/UN`);
}

export const getCanbotSemesterInfo = (resultCode: number): AxiosPromise<IGetCanbotEvaluationItemResponse> => {
  return axios.get(`${uri}/e-learning/canbot/semester-info/${resultCode}`);
}

export const saveCanbotEvaluation = (resultCode: number, formData: FormData): AxiosPromise => {
  return axios.put(`${uri}/e-learning/canbot/evaluation/${resultCode}`, formData);
}
